/**
 * I sette file di testo, caricati uno per volta.
 *
 * Si carica **solo la lingua scelta**: infilare tutte e sette nel pacchetto principale
 * sarebbe sei settimi di byte scaricati per niente a ogni avvio, su una rete che in casa
 * è quasi sempre Wi-Fi mediocre (07-PRESTAZIONI §7).
 */

import type { Locale, Messages } from '@player/ui';

const LOADERS: Readonly<Record<Locale, () => Promise<{ default: Messages }>>> = {
  en: () => import('@player/ui/messages/en.json'),
  it: () => import('@player/ui/messages/it.json'),
  es: () => import('@player/ui/messages/es.json'),
  fr: () => import('@player/ui/messages/fr.json'),
  de: () => import('@player/ui/messages/de.json'),
  pl: () => import('@player/ui/messages/pl.json'),
  tr: () => import('@player/ui/messages/tr.json'),
};

export async function loadMessages(locale: Locale): Promise<Messages> {
  const module = await LOADERS[locale]();
  return module.default;
}
